/* eslint-disable */
import { gsap } from 'gsap';

export default {
  init() {
    console.log('hello home');
    // Navigation - navbar secondary
    const navbarSecondary = document.querySelector('#navbar-secondary');
    window.addEventListener('scroll', function () {
      menuSetState();
    });

    menuSetState();

    function menuSetState() {
      if ((window.matchMedia("(min-width: 1200px)").matches)) {
        if (window.scrollY >= 100 && !navbarSecondary.classList.contains('collapsed')) {
          navbarSecondary.classList.add('collapsed');
        } else if (window.scrollY < 100 && navbarSecondary.classList.contains('collapsed')) {
          navbarSecondary.classList.remove('collapsed');
          if (navbarSecondary.classList.contains('opened')) {
            navbarSecondary.classList.remove('opened');
          }
        }
      } else {
        navbarSecondary.classList.add('collapsed');
      }
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js